export default {_name:'Text.StatusChip',module:'Field',view:'Element/Text/StatusChip',options:{md:12}}